import Framework7 from 'framework7/bundle';
import Framework7Keypad from 'framework7-plugin-keypad';
import 'framework7/css/bundle';
import 'framework7-icons/css/framework7-icons.css';
import 'material-icons/iconfont/material-icons.css';

import $ from 'jquery';
window.jQuery = $;
import 'jquery-validation';

import AppPage from '../components/app.f7.html';

if (process.env.NODE_ENV === 'development') {
  import('./eruda.js');
}

import config from './config.js';
import routes from './routes.js';
import store from './store.js';
import '../styles/app.css';
import '../styles/colors.css';



Framework7.prototype.config = config;
Framework7.use(Framework7Keypad);

console.log('BEFORE F7 DEFINED');

const app = new Framework7({
  el: '#app',
  component: AppPage,
  id: config.app.id,
  name: config.app.title,
  version: config.app.version,
  theme: config.theming.theme == 'auto' ? (Framework7.device.desktop ? 'aurora': 'auto'): config.theming.theme,
  autoDarkMode: config.theming.enabled && localStorage.getItem('Theme_Mode') == 'system' || config.theming.mode == 'system',
  routes,
  store,
  init: false,
  initOnDeviceReady: false,
  view: {
    iosDynamicNavbar: false,
    stackPages: true,
    routesBeforeEnter: [checkAuthStatus]
  }
});

console.log('AFTER F7 DEFINED');


/*
|------------------------------------------------------------------------------
| App Events
|------------------------------------------------------------------------------
*/

app.on('init', function() {
  
  //app.check();
  //app.getComputedStyles();
  //app.layout.initialize();
  //app.theming.initialize();
  //app.i18n.initialize();
  //app.a2hs.initialize();
  //app.zooming.initialize();

  //app.admob.initialize();
  //app.wordpress.initialize();
});



/* Show Preloader Before Route Is Loaded */
app.on('routerAjaxStart', function(xhr, options) {
  app.preloader.show();
});

/* Hide Preloader After Route Is Loaded */
app.on('routerAjaxComplete', function(xhr, options) {
  app.preloader.hide();
});

/* Show Error If Unable To Load Route */
app.on('routerAjaxError', function(xhr, options) {
  app.toast.show({
    text: app.i18n.translate('error-loading-route', 'An error occured while loading page.'),
    horizontalPosition: 'center',
    position: 'bottom',
    cssClass: 'color-red'
  });
});

/* Close Modals Before Page Is Removed */
app.on('pageBeforeRemove', function(page) {
  app.actions.close();
  app.calendar.close();
  app.dialog.close();
  app.notification.close();
  app.picker.close();
  app.popover.close();
  app.popup.close();
  app.sheet.close();
});

app.getCurrentTimestamp = function() {
  const time = new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(new Date()).replace(' ', 'T')

  return time;
}
/*
|------------------------------------------------------------------------------
| Get Computed Styles
|------------------------------------------------------------------------------
*/

app.getComputedStyles = function() {
  app.stylesheet = window.getComputedStyle(document.documentElement);
}

/*
|------------------------------------------------------------------------------
| Layout
|------------------------------------------------------------------------------
*/

app.layout = {
  initialize: function() {
    app.on('pageAfterIn', function(page) {
      if (page.$el.hasClass('no-sidebar')) {
        app.panel.close('#sidebar');
      }
    });

    app.on('pageAfterIn',
      function(page) {
        if (page.$el.hasClass('no-tabbar')) {
          app.tabbar.hide('#tabbar');
        }
      });

    app.on('pageBeforeRemove',
      function(page) {
        if (page.$el.hasClass('no-tabbar')) {
          app.tabbar.show('#tabbar');
        }
      });
  },

  handleBackButton: function() {
    if (app.$('.dialog.modal-in').length) return;

    if (app.$('.popup.modal-in').length) {
      app.popup.close('.popup.modal-in');
      return;
    }

    if (app.$('.sheet-modal.modal-in').length) {
      app.sheet.close('.sheet-modal.modal-in');
      return;
    }

    if (app.$('.popover.modal-in').length) {
      app.popover.close('.popover.modal-in');
      return;
    }

    if (app.$('.actions-modal.modal-in').length) {
      app.actions.close('.actions-modal.modal-in');
      return;
    }

    if (app.$('.panel.panel-in').length) {
      app.panel.close('.panel.panel-in');
      return;
    }

    const currentView = app.views.current;

    if (currentView?.router?.history?.length > 1) {
      currentView.router.back();
    }
  }
};

/*
|------------------------------------------------------------------------------
| Sidebar
|------------------------------------------------------------------------------
*/

app.sidebar = {
  show: function() {
    const sidebar = app.panel.get('#sidebar');

    if (sidebar) {
      sidebar.enableSwipe();
      sidebar.enableVisibleBreakpoint();
      sidebar.enableCollapsedBreakpoint();
    }
  },

  hide: function() {
    const sidebar = app.panel.get('#sidebar');

    if (sidebar) {
      sidebar.disableSwipe();
      sidebar.disableVisibleBreakpoint();
      sidebar.disableCollapsedBreakpoint();
      sidebar.close();
    }
  },

  toggle: function() {
    const sidebar = app.panel.get('#sidebar');

    if (!sidebar) return;

    const width = window.innerWidth;

    if (
      width >= sidebar.params.collapsedBreakpoint &&
      width < sidebar.params.visibleBreakpoint
    ) {
      sidebar.toggleCollapsedBreakpoint();
    } else {
      sidebar.toggle();
    }
  }
};

/*
|------------------------------------------------------------------------------
| Tabbar
|------------------------------------------------------------------------------
*/

app.tabbar = {
  show: function() {
    const tabbar = app.$('#tabbar');

    if (tabbar.length) {
      app.toolbar.show(tabbar, false);
    }
  },

  hide: function() {
    const tabbar = app.$('#tabbar');

    if (tabbar.length) {
      app.toolbar.hide(tabbar, false);
    }
  }
};

/*
|------------------------------------------------------------------------------
| Theming
|------------------------------------------------------------------------------
*/

app.theming = {
  config: app.config.theming,

  initialize: function() {
    const color = this.config.enabled
    ? localStorage.getItem('Theme_Color') || this.config.color: this.config.color;

    const mode = this.config.enabled
    ? localStorage.getItem('Theme_Mode') || this.config.mode: this.config.mode;

    this.changeColor(color);
    this.changeMode(mode);
  },

  currentColor: function() {
    return app.stylesheet.getPropertyValue('--f7-theme-color').trim();
  },

  currentMode: function() {
    return app.$('html').hasClass('dark')
    ? 'dark': app.params.autoDarkMode
    ? 'system': 'light';
  },

  changeColor: function(color) {
    const properties = app.utils.colorThemeCSSProperties(color);

    if (Object.keys(properties).length) {
      const style = document.createElement('style');

      style.textContent = `
      :root {
      ${Object.keys(properties)
      .map(key => `${key}: ${properties[key]};`)
      .join('\n')}
      }
      `;

      document.head.appendChild(style);
    }

    store.dispatch('setThemeColor', color);

    if (this.config.enabled) {
      localStorage.setItem(
        'Theme_Color',
        color || this.config.color
      );
    }
  },

  changeMode: function(mode) {
    switch (mode) {
      case 'dark':
        app.$('html').addClass('dark');
        app.disableAutoDarkMode();
        app.params.autoDarkMode = false;
        break;

      case 'light':
        app.$('html').removeClass('dark');
        app.disableAutoDarkMode();
        app.params.autoDarkMode = false;
        break;

      case 'system':
        case 'auto':
          default:
            app.enableAutoDarkMode();
            app.params.autoDarkMode = true;
            break;
      }

      store.dispatch('setThemeMode', mode);

      if (this.config.enabled) {
        localStorage.setItem(
          'Theme_Mode',
          mode || this.config.mode
        );
      }
    }
  };

  /*
|------------------------------------------------------------------------------
| Component - Form Validator
|------------------------------------------------------------------------------
*/

  app.on('init', function() {
    app.formValidator.initialize();
  });

  app.formValidator = {
    initialize: function() {
      if ('jQuery' in window && 'validator' in jQuery) {
        jQuery.validator.setDefaults({
          ignore: [],
          errorClass: 'item-input-error-message',
          errorElement: 'div',
          errorPlacement: function(error, element) {
            jQuery(element).parents('.item-input').addClass('item-input-with-error-message');
            jQuery(element).parents('.item-input').addClass('item-input-invalid');
            error.appendTo(element.parents('.item-input-wrap'));
          },
          highlight: function(element, errorClass, validClass) {
            jQuery(element).parents('.item-input').addClass('item-input-with-error-message');
            jQuery(element).parents('.item-input').addClass('item-input-invalid');
            jQuery(element).removeClass(errorClass);
          },
          unhighlight: function(element, errorClass, validClass) {
            jQuery(element).parents('.item-input').removeClass('item-input-with-error-message');
            jQuery(element).parents('.item-input').removeClass('item-input-invalid');
          },
          success: function(label, element) {
            jQuery(element).parents('.item-input').removeClass('item-input-with-error-message');
            jQuery(element).parents('.item-input').removeClass('item-input-invalid');
            jQuery(element).parents('.item-input').find('.item-input-error-message').remove();
          }
        });

        jQuery.validator.addMethod(
          'regex',
          function(value, element, regexp) {
            if (regexp.constructor != RegExp) {
              regexp = new RegExp(regexp);
            } else if (regexp.global) {
              regexp.lastIndex = 0;
            }
            return this.optional(element) || regexp.test(value);
          },
          ''
        );
      }
    }
  };
  
  /*
|------------------------------------------------------------------------------
| Utility Functions
|------------------------------------------------------------------------------
*/

  /* Get Random Value From Array */
  Array.prototype.random = function(count) {
    if (count) {
      const shuffled = [...this].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, count);
    }

    return this[Math.floor(Math.random() * this.length)];
  };

  /* Convert Data URL To Blob */
  app.dataUrlToBlob = function(dataUrl) {
    const [header,
      data] = dataUrl.split(',');
    const mime = header.match(/data:(.*?);/)?.[1] || 'application/octet-stream';
    const byteString = atob(data);
    const bytes = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
      bytes[i] = byteString.charCodeAt(i);
    }

    return new Blob([bytes], {
      type: mime
    });
  };

  /* Check If Element Is In Viewport */
  app.elementInViewport = function(element) {
    const bounding = element.getBoundingClientRect();

    return (
      bounding.top >= -32 &&
      bounding.left >= -32 &&
      bounding.bottom <= window.innerHeight + 32 &&
      bounding.right <= window.innerWidth + 32
    );
  };

  /* Get App Version */
  app.getAppVersion = function() {
    return app.version;
  };

  /* Get External URL Target */
  app.getExternalUrlTarget = function() {
    return '_blank';
  };

  /* Open External URL */
  app.openExternalUrl = function(url, target) {
    window.open(url, target || '_blank');
  };

  /* Remove Diacritics */
  app.removeDiacritics = function(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  /* Render Unicode */
  app.renderUnicode = function(unicode) {
    return String.fromCodePoint(parseInt(unicode, 16));
  };

  /* Scroll To Element */
  app.scrollTo = function(selector) {
    const element = app.$(selector);

    if (element.length) {
      element[0].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
    });
  }
};
/*
|------------------------------------------------------------------------------
| Zooming
|------------------------------------------------------------------------------
*/

app.zooming = {
  config: app.config.zooming,

  initialize: function() {
    if (!this.config.enabled) return;

    this.changeValue(this.currentValue());
  },

  currentLevel: function() {
    if (!this.config.enabled) return;

    const levels = Object.keys(this.config.levels);
    const saved = localStorage.getItem('Zooming_Level');

    if (levels.includes(saved)) {
      return this.config.levels[saved];
    }

    if (levels.includes(this.config.defaultLevel)) {
      return this.config.levels[this.config.defaultLevel];
    }

    return {
      name: 'Normal',
      slug: 'normal',
      value: '100%'
    };
  },

  changeLevel: function(level) {
    if (!this.config.enabled) return;

    if (!Object.keys(this.config.levels).includes(level)) return;

    const newLevel = this.config.levels[level];

    this.changeValue(parseInt(newLevel.value));

    localStorage.setItem('Zooming_Level', level);
  },

  currentValue: function() {
    if (!this.config.enabled) return;

    const saved = localStorage.getItem('Zooming_Value');

    if (saved) {
      return parseInt(saved);
    }

    const zoom = parseFloat(app.$('body').css('zoom'));

    return zoom ? zoom * 100: 100;
  },

  changeValue: function(value) {
    if (!this.config.enabled) return;

    value = parseInt(value);

    if (!value || value < 50 || value > 200) {
      value = 100;
    }

    app.$('body').css({
      zoom: value + '%',
      '-webkit-text-size-adjust': value + '%',
      'text-size-adjust': value + '%'
    });

    localStorage.setItem('Zooming_Value', value);
  }
};

/*
|------------------------------------------------------------------------------
| Check Auth Status
|------------------------------------------------------------------------------
*/


function checkAuthStatus( { to, from, resolve, reject }) {
  console.log("checkAuthStatus", store.state.isUserLoggedIn, to, from);
  let router = this;
  if (app.config.navigation.authentication.required) {
    if (store.state.isUserLoggedIn) {
      console.log("isUserLoggedIn", store.state.isUserLoggedIn);
      resolve();
    } else {
      if (app.config.navigation.authentication.ignoreRoutes.includes(to.path)) {
        resolve();
      } else {
        reject();
        console.log('to login');
        router.navigate(
          {
            url: '/login/?redirect=' + to.path,
          },
          {
            reloadCurrent: true
          }
        );
        return;
      }
    }
  } else {
    resolve();
  }
}


window.app = app;

store.dispatch('init');